import { FILTER_KEY } from '@/ducks/filters/types';
import { getSearchParamsKeys, getSearchParamsValue } from '@/ducks/filters/utils/primitive';
import { QF_ADDITIONAL_PARAMS, QF_SEARCH_PARAMS } from '@/features/quickFindFilters/searchParams';

import type { TQuickFindLink } from './types';

export const getQFBaseSearchParams = (QFLink?: TQuickFindLink) => {
  const params = new URLSearchParams();
  if (!QFLink) {
    return params;
  }

  params.set(QF_SEARCH_PARAMS.quickFindID, QFLink.quickFindId ?? '');

  const linkParams = new URLSearchParams(QFLink.linkUrl ?? '');
  const linkAdditionalParams = getQFAdditionalParams(QFLink);

  Object.values(FILTER_KEY).forEach((filterKey) => {
    const key = getSearchParamsKeys(filterKey)[0] ?? filterKey;
    const value = getSearchParamsValue(filterKey, linkParams);
    if (key && value && !linkAdditionalParams.has(key)) {
      params.set(key, value as string);
    }
  });

  return params;
};

export const getQFAdditionalParams = (QFLink?: TQuickFindLink) => {
  const params = new URLSearchParams();
  if (!QFLink) {
    return params;
  }

  const linkParams = new URLSearchParams(QFLink.linkUrl ?? '');

  Object.values(QF_ADDITIONAL_PARAMS).forEach((filterKey) => {
    const key = getSearchParamsKeys(filterKey)[0] ?? filterKey;
    const value = getSearchParamsValue(filterKey, linkParams);
    if (key && value) {
      params.set(key, value as string);
    }
  });

  return params;
};

export const getQFSearchParams = (QFLink?: TQuickFindLink) =>
  new URLSearchParams([...getQFBaseSearchParams(QFLink), ...getQFAdditionalParams(QFLink)]);
